import { defineRecipe } from '@chakra-ui/react';

export const searchInputRecipe = defineRecipe({
  base: {
    color: 'text.secondary',
    fontSize: 'md',
    bg: 'surface.input',
    pr: '2.5',
    pl: '8',
    _placeholder: {
      color: 'text.secondary',
    },
  },
  variants: {
    size: {
      sm: { height: '7', fontSize: 'sm', pr: '2', pl: '7' },
      md: { height: '9', fontSize: 'md', pr: '2.5', pl: '8' },
      lg: { height: '10', fontSize: 'lg', pr: '3', pl: '9' },
    },
    visual: {
      border: {
        border: '1px',
        borderColor: 'border.tertiary',
        borderRadius: 'md',
        boxShadow: 'sm',
        _focusVisible: {
          borderColor: 'border.action',
          boxShadow: '0 0 0 1px var(--chakra-colors-border-action)',
        },
      },
      flat: {
        border: '0',
        borderRadius: '0',
        boxShadow: 'none',
        color: 'text.primary',
        _placeholder: { color: 'text.primary' },
        _focusVisible: {
          boxShadow: '0 0 0 1px var(--chakra-colors-border-action)',
        },
      },
      outline: {
        border: '1px',
        borderColor: 'border.tertiary',
        borderRadius: 'md',
        bg: 'transparent',
        boxShadow: 'sm',
        color: 'text.primary',
        _placeholder: { color: 'text.primary' },
        _focusVisible: {
          borderColor: 'border.action',
          boxShadow: '0 0 0 1px var(--chakra-colors-border-action)',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
    visual: 'border',
  },
});
